<template>
  <div class="content">
    <div :class="{bg: true, empty: list && list.length === 0}">
      <div class="filter">
        <div class="item">
          <div class="left">
            <span class="title">创建日期</span>
            <date-picker v-model="datePicker" placeholder="    选择时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
          </div>
          <div class="create" @click="goCreate()" v-if="showCreate">
            <img src="@assets/img/topics/create.svg" alt="create" class="icon">
            <span>{{`新建${$_syscfg.topic}`}}</span>
          </div>
        </div>
        <div class="item" v-for="(f, d) in filters" :key="d">
          <div class="left">
            <span class="title">{{f.title}}</span>
            <div :class="{conditions: true, expanded: f.expand}">
              <p :class="{condition: true, on: c.selected}" v-for="(c, i) in f.list" :key="i" @click="selectCondition(c, f)">
                {{c.title}}
              </p>
            </div>
            <div class="expander" @click="changeExpand(f)" v-if="f.list.length > 10">
              <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
            </div>
          </div>
        </div>
      </div>
      <div class="headline">
        <span class="title">主题</span>
        <span class="publisher">发布者</span>
        <span class="time">发布时间</span>
        <span class="related">相关内容</span>
        <span class="handle">操作</span>
      </div>
      <empty :mTop="30" :msg="`暂无${$_syscfg.topic}数据`" v-if="list && list.length === 0" />
      <div class="items" v-for="(l, i) in list" :key="i">
        <div class="content">
          <div class="item">
            <div class="title">
              <p class="words" @click="goDetail(l.id)" :title="l.title">
                {{l.title}}
              </p>
              <span class="msg" v-if="l.remark">
                <img src="@assets/img/index/remark.svg" alt="remark">
                <div class="remark">
                  <p>
                    {{l.remark}}
                  </p>
                </div>
              </span>
            </div>
            <div class="publisher card" @click="showCard(l.uid, $event)">{{l.user_name}}</div>
            <div class="time">{{l.raw_add_time}}</div>
            <div class="related" @click="toggleRelated(l)">
              {{l.content_num}}
              <img :src="l.showRelated ? icons.up : icons.down" alt="icon" class="icon" v-if="l.content_num - 0 > 0">
            </div>
            <div class="handle">
              <div class="btn" @click="goItv(l)" v-if="l.has_interview_role">
                发布任务
              </div>
            </div>
          </div>
        </div>
        <div class="childContent" v-for="(c, d) in l.related10" v-show="l.showRelated" :key="d">
          <div class="child">
            <div class="title" @click="goRelateDetail(c)">
              <span class="tag">
                {{c.type_name}}
              </span>
              <p class="words">
                {{c.title}}
              </p>
            </div>
            <div class="publisher">{{l.user_name}}</div>
            <div class="time">{{l.raw_add_time}}</div>
            <div class="related" :style="{visibility: 'hidden'}"></div>
            <div class="handle" :style="{visibility: 'hidden'}"></div>
          </div>
        </div>
        <div class="childContent" v-if="l.content_num - 0 > 10 && l.showRelated">
          <div class="child more">
            <div class="showMore" @click="goDetail(l.id)">
              查看更多
            </div>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import DatePicker from 'vue2-datepicker'
import common from '@common/common'
import { apis } from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'topics',
  components: {
    pages, DatePicker, empty
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1
        this.filterOptions['create_time'] = common.stampToTime(n)
        this.getList()
      }
    }
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      page: {
        page_count: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      datePicker: '',
      icons: {
        up: require('@assets/img/topics/up.svg'),
        down: require('@assets/img/topics/down.svg'),
        downward: require('@assets/img/common/xiala.svg'),
        upward: require('@assets/img/common/upward.svg')
      },
      list: null,
      filters: [],
      searchOptions: {},
      filterOptions: {},
      selectedTag: '',
      showCreate: false
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    changeExpand(c) {
      // 切换类目展开／收起
      this.$set(c, 'expand', !c.expand)
    },
    autoSelectTag() {
      // 自动选标签
      const tag = this.selectedTag
      if (!tag) return

      this.filters.forEach(i => {
        if (i.key === 'tag_id') {
          i.list.forEach(j => {
            if (tag === j.title) {
              this.selectCondition(j, i)
            }
          })
        }
      })
      this.selectedTag = ''
    },
    goRelateDetail(r) {
      const id = r.id

      if (r.type === 'interview') {
        this.$router.push({
          path: '/interviewDetail',
          query: {
            r: id
          }
        })
      } else if (r.type === 'material') {
        common.jump(`/clueDetail?d=${id}`, true)
      } else if (r.type === 'report') {
        common.jump(`/reportDetail?d=${id}`, true)
      }
    },
    goItv(l) {
      // 发布选题，去采访
      const t = {
        id: l.id,
        title: l.title
      }

      // this.$router.push({
      //   name: 'newInterview',
      //   params: {
      //     topic: t
      //   }
      // })

      dc.setTpc(t)

      common.jump(`/newInterview`, true)

      setTimeout(() => {
        dc.delTpc()
      }, 500)
    },
    selectCondition(c, f) {
      // 选择筛选条件（多选）
      this.page.pageIndex = 1
      this.$set(c, 'selected', !c.selected)
      this.$nextTick(() => {
        const selected = []
        f.list.forEach((i) => {
          if (i.selected) {
            selected.push(i.key)
          }
        })
        this.filterOptions[f.key] = selected.join(',')
        this.getList()
      })
    },
    handleRelatedData(i, d) {
      // 处理关联内容数据
      const related10 = d.slice(0, 10)

      this.$set(i, 'related', d)
      this.$set(i, 'related10', related10)
    },
    getRelated(i) {
      // 获取关联内容
      const info = {
        id: i.id
      }

      common.myFetch(apis.Tpc_list_withs, info)
        .then(d => {
          this.handleRelatedData(i, d.list)
        })
    },
    getList(keyWord) {
      // 获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        create_time: '',
        tag_id: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }
      
      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.Tpc_list, info)
        .then((data) => {
          this.list = data.list
          this.generateSearchs(data.params.top_search.option.list)
          this.generateFilters(data.params.list_search)
          this.autoSelectTag()
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
          this.showCreate = data.has_add_role
        })
    },
    generateFilters(data) {
      // 处理过滤条件数据
      const filters = data.filter((i) => {
        return i.key !== 'create_time'
      })

      if (this.filters.length === 0) {
        this.filters = filters
      }
    },
    generateSearchs(data) {
      // 处理搜索框数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据并查询列表
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    toggleRelated(i) {
      // 展示／隐藏 相关信息
      if (!i.related && i.content_num - 0 > 0) {
        this.getRelated(i)
      }

      this.$set(i, 'showRelated', !i.showRelated)
    },
    goDetail(i) {
      // 跳转详情页
      // this.$router.push({
      //   path: '/topicDetail',
      //   query: {
      //     d: i,
      //     f: 'l'
      //   }
      // })

      common.jump(`/topicDetail?d=${i}&f=l`, true)
    },
    goCreate() {
      // 跳转新建页
      // this.$router.push({
      //   path: '/newTopic'
      // })

      common.jump(`/newTopic`, true)
    }
  },
  mounted() {
    this.selectedTag = this.$route.params.tag

    this.getList('noKeyWord')
  }
}
</script>

<style lang="less" scoped src="@assets/css/topic/topics.less"></style>
